module.exports = __webpack_public_path__ + "static/media/Impact Card anomalies.79fde4da.txt";